import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import TranscribeJobStateDisplay from '../../TranscribeJobStateDisplay';

const SummaryEmpty = () => {
  return (
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontWeight: 500, textAlign: 'left', mb: 1 }}
        >
          <TranscribeJobStateDisplay />
        </Typography>
      </Box>
      <Box>
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="100%" height={24} />
        <Skeleton variant="text" width="80%" height={24} />
      </Box>
    </Box>
  );
};

export default SummaryEmpty;
